import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';

import MoreVertIcon from '@mui/icons-material/MoreVert';

import { TypeActionCodes } from 'constants.js';

class ActionsSpecifiquesSelect extends React.Component {

    state = {
        anchorEl: null
    };

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleClickItem = (event) => {
        this.setState({ anchorEl: null });
        this.props.onClickItem(event);
    };

    render() {
        const { actions, iconButtonSx, reclamationSurBonDeVenteCle } = this.props;
        const { anchorEl } = this.state;

        if (actions.length === 0) {
            return null;
        }

        // Une réclamation sur bon de vente existe déjà → on désactive l'action de déclenchement.
        const recentExistant = !!reclamationSurBonDeVenteCle;

        return (
            <React.Fragment>
                <Tooltip title="Actions spécifiques au groupe">
                    <IconButton onClick={this.handleClick} size="large" sx={iconButtonSx}>
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>

                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.handleClose}>

                    {actions.map(action => {
                        const desactive = action.code === TypeActionCodes.GenerationRecent && recentExistant;

                        const menuItem = (
                            <MenuItem
                                key={action.id}
                                value={action.id}
                                onClick={this.handleClickItem}
                                disabled={desactive}
                            >
                                {action.libelle}
                            </MenuItem>
                        );

                        // Tooltip sur un MenuItem désactivé : nécessite un wrapper (span) pour capter le survol.
                        return desactive
                            ? (
                                <Tooltip key={action.id} title="Réclamation sur bon de vente déjà existante pour ce dossier">
                                    <span>{menuItem}</span>
                                </Tooltip>
                            )
                            : menuItem;
                    })}
                </Menu>
            </React.Fragment>
        );
    }
}

ActionsSpecifiquesSelect.propTypes = {
    actions: PropTypes.array.isRequired,
    onClickItem: PropTypes.func.isRequired,
    iconButtonSx: PropTypes.object,
    reclamationSurBonDeVenteCle: PropTypes.string
};

export default ActionsSpecifiquesSelect;